import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, updated, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div data-testid="legal-page">
      <Navbar />
      <section className="pt-36 pb-16 border-b border-white/10">
        <div className="max-w-[900px] mx-auto px-4 md:px-8">
          <Link
            to="/"
            data-testid="legal-back"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-accent transition-colors mb-8"
          >
            <ArrowLeft size={16} /> Back to home
          </Link>
          <h1 className="font-display text-4xl md:text-6xl tracking-tight">{title}</h1>
          <p className="text-sm text-muted-foreground mt-4">Last updated: {updated}</p>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-[900px] mx-auto px-4 md:px-8 prose-legal space-y-10">
          {children}
        </div>
      </section>
      <Footer />
    </div>
  );
}

export function LegalBlock({ heading, children }) {
  return (
    <div>
      <h2 className="font-display text-2xl md:text-3xl mb-4">{heading}</h2>
      <div className="text-muted-foreground leading-relaxed space-y-4 text-base">{children}</div>
    </div>
  );
}
